<template>
    <div class="ConfirmEmailChange">
        <SiteHeader/>

        <Container>
            <div v-if="!submitSuccess">
                <h1>Confirm Email Change</h1>
                <Card>
                    <form @submit.prevent="handleSubmit">
                        <p>Are you sure you want to change your email to <strong>{{ email }}</strong>?</p>
                        <Button class="primary block" type="submit" :disabled="submitPending">Confirm Change</Button>
                    </form>
                </Card>
            </div>
            <div v-else>
                <h1>Success!</h1>
                <Card>
                    <p>Your email has successfully been updated.</p>
                </Card>
            </div>
        </Container>

        <SiteFooter/>
    </div>
</template>

<script>
import * as api from '@/api';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Card from '@/components/Card';

export default {
    name: 'ConfirmEmailChange',

    data: () => ({
        token: null,
        email: null,
        submitPending: false,
        submitSuccess: false,
    }),

    components: {
        SiteHeader,
        SiteFooter,
        Card,
    },

    mounted() {
        this.token = this.$router.currentRoute.query.token;
        this.email = this.$router.currentRoute.query.email;
    },

    methods: {
        async handleSubmit() {
            if (this.submitPending) return;

            this.submitPending = true;
            const res = await api.confirmEmailChange({ token: this.token });
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Failed to change email');
            }

            this.submitSuccess = true;
            this.$store.dispatch('auth/refreshUser');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ConfirmEmailChange {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        margin-top: 30px;
        margin-bottom: 80px;
        text-align: center;

        h1 {
            @extend %display-subtitle;
            margin-bottom: 30px;
        }

        p {
            @extend %display-description;
            margin: 0 auto 30px;
        }
    }

    .Card {
        max-width: 600px;
        margin: 0 auto;
    }

    .SiteFooter {
        align-self: flex-end;
    }
}
</style>
